import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'

import { mplusStore } from 'entities/mplus/module/mplus-store'

import { priceShow } from 'shared/lib/priceShow'

import { getMonthName } from './lib/getMonth'
import s from './styles.module.scss'

export const TakeInMplus = observer(() => {
  const { t } = useTranslation()

  const installmentInfo = mplusStore.getInstallmentInfo()
  return (
    <div className={s.takeInMplus}>
      <h4 className={clsx(s.title, 'semi-bold-20')}>
        {t('mplus.if_take_mplus')}
      </h4>

      <div className={s.calculator}>
        <div className={s.header}>
          <h4 className={clsx(s.duration, 'bold-22')}>
            {installmentInfo?.month} {t('mplus.month')}
          </h4>
          <p className={clsx(s.factor, 'bold-22')}>x</p>
          <h4 className={clsx(s.price, 'bold-22')}>
            {priceShow(installmentInfo?.monthly_amount)} &#8384;
          </h4>
        </div>

        <div className={s.calendar}>
          <div className={s.card}>
            <hr className={clsx(s.divider, s.active)} />
            <div className={s.text}>
              <h6 className={clsx(s.summ, 'medium-12')}>0 &#8384;</h6>
              <p className={clsx(s.date, 'medium-12')}>{t('now')}</p>
            </div>
          </div>

          {installmentInfo?.schedule.map((item) => (
            <div
              className={s.card}
              key={nanoid()}
            >
              <hr className={s.divider} />
              <div className={s.text}>
                <h6 className={clsx(s.summ, 'medium-12')}>
                  {priceShow(item.amount)} &#8384;
                </h6>
                <p className={clsx(s.date, 'medium-12', s.grey)}>
                  {getMonthName(item)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})
